const ConstApiUrls = {
  // AUTH_SERVICE_URL: 'http://localhost:8091/api/auth/',
  // TEST_SERVICE_URL: 'http://localhost:8091/api/test/',
  // API_SERVICE_URL: 'http://localhost:8091/api/dpmdbekasi/',

  AUTH_SERVICE_URL: 'https://rest-dpmd.bekasikab.go.id/api/auth/',
  TEST_SERVICE_URL: 'https://rest-dpmd.bekasikab.go.id/api/test/',
  API_SERVICE_URL: 'https://rest-dpmd.bekasikab.go.id/api/dpmdbekasi/',

  // AUTH_SERVICE_URL: 'https://rest-dpmd-bekasikab.des-green.org/api/auth/',
  // TEST_SERVICE_URL: 'https://rest-dpmd-bekasikab.des-green.org/api/test/',
  // API_SERVICE_URL: 'https://rest-dpmd-bekasikab.des-green.org/api/dpmdbekasi/',



};
export default ConstApiUrls;
